import { render, staticRenderFns } from "./kefuMobile.vue?vue&type=template&id=52784d68&scoped=true"
import script from "./kefuMobile.vue?vue&type=script&lang=js"
export * from "./kefuMobile.vue?vue&type=script&lang=js"
import style0 from "./kefuMobile.vue?vue&type=style&index=0&id=52784d68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52784d68",
  null
  
)

export default component.exports